import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

export const getAdminOrganizationTelephonyConfig = async (organizationId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `admin/organizations/${organizationId}/telephony-config`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to load telephony configuration");
};

export const updateAdminOrganizationTelephonyConfig = async (organizationId, config) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `admin/organizations/${organizationId}/telephony-config`,
    data: config,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update telephony configuration");
};
